module.exports = __webpack_public_path__ + "img/sj_gangtiemaoyi.358de14d.jpg";